module.exports = __webpack_public_path__ + "a4dd6e97ce4bd34161c77f5ec8306c55.svg";